import "./home.css";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { MdSettingsPower } from "react-icons/md";
import { IoAnalyticsSharp } from "react-icons/io5";
import { BsFillGeoAltFill } from "react-icons/bs";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { AiFillSetting } from "react-icons/ai";
import { RiBarChartFill } from "react-icons/ri";
import { RiCloudFill } from "react-icons/ri";
import { AiFillDatabase } from "react-icons/ai";
import { FaCarAlt } from "react-icons/fa";
import { MdSettingsVoice } from "react-icons/md";
import { MdRecordVoiceOver } from "react-icons/md";

//import { useHistory } from "react-router-dom";

import axios from "axios";

export default function Home(props) {
  const currentuser = props.logedinuser;

  const axiosJWT = axios.create();
  //let history = useHistory();
  const handleLogout = async (e) => {
    document.location.reload(true);
    localStorage.removeItem("location");
    try {
      const res = await axiosJWT.post(
        "https://services.lafemasystems.co.ke/api/logout",
        {
          headers: { authorization: "Bearer " + currentuser.refreshToken },
        }
      );
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="home">
      <div className="introduction">
        <div className="fir">
          <BsFillPersonCheckFill className="usericon" />
          <h2>Welcome Back {currentuser.userName} </h2>
        </div>
        <div className="fir firstt">
          <BsFillGeoAltFill className="usericon" />
          <h2>Real Time Location </h2>
        </div>
        <div className="fir">
          <IoAnalyticsSharp className="usericon" />
          <h2>Data Analytics </h2>
        </div>
      </div>

      <div className="introduction">
        <div className="fir">
          <RiBarChartFill className="usericon" />
          <h2>Vehicle Reports </h2>
        </div>
        <div className="fir firstt">
          <AiFillDatabase className="usericon" />
          <h2>Fleet Data </h2>
        </div>
        <div className="fir">
          <FaCarAlt className="usericon" />
          <h2>Vehicle Management </h2>
        </div>
      </div>

      <div className="introduction">
        <div className="fir">
          <MdSettingsVoice className="usericon" />
          <h2>Voice Recording </h2>
        </div>
        <div className="fir firstt">
          <MdRecordVoiceOver className="usericon" />
          <h2>Stranger Recognition </h2>
        </div>
        <div className="fir">
          <RiCloudFill className="usericon" />
          <h2>Remote AI Analysis </h2>
        </div>
      </div>

      <div className="introduction">
        <div className="fir">
          <AiFillSetting className="usericon" />
          <h2>Settings </h2>
        </div>
        <div className="fir firstt">
          <IoNotificationsCircleSharp className="usericon" />
          <h2>Notifications </h2>
        </div>
        <div className="fir">
          <MdSettingsPower className="usericon" />
          <h2 onClick={handleLogout}>Logout</h2>
        </div>
      </div>
    </div>
  );
}
